import React from "react";
import { withRouter } from "react-router-dom";
import { logoImage } from "../../../../assets/index";
const Header = (props) => (
  <div className="main-bg">
    <header>
      <div className="container-fluid">
        <div className="logo logo-center">
          <img
            src={logoImage}
            className="pointer-point"
            onClick={() => props.history.push("/")}
            height={"48px"}
            alt="LA Moving Star"
            title="LA Moving Star"
          />
        </div>
      </div>
    </header>
  </div>
);

export default withRouter(Header);
